export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Mention-Gray-689c0887794a072a00221e3e1961136e.svg";